console.log('Nav loaded');
export const nav = () => {
  
        // Remove hidden class from mobileNav
        const $mobileNav = document.querySelector('.mobileNav');

        if ($mobileNav) {
            $mobileNav.classList.remove('is-hidden');
        }

        // Get all "navbar-burger" elements
        const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

        // Check if there are any navbar burgers
        if ($navbarBurgers.length > 0) {
            // Add a click event on each of them
            $navbarBurgers.forEach(el => {
                el.addEventListener('click', () => {
                    console.log('burger clicked');
                    // Get the target from the "data-target" attribute
                    const target = el.dataset.target;
                    const $target = document.getElementById(target);

                    // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                    el.classList.toggle('is-active');
                    $target.classList.toggle('is-active');

                });
            });

            const $mobileNavLi = document.getElementById('navMenu');
            const $navbarBurger = document.getElementById('mobileTrigger');

            // Listen for click events on body
            document.body.addEventListener('click', function (event) {
                //console.log('clicked');
                
                //$('#pageContent').load(location.href +' #pageContent');
                if ($mobileNavLi.contains(event.target)) {
                    // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                    //$mobileNavLi.classList.toggle('is-active');
                    //$navbarBurger.classList.toggle('is-active');

                    var firstElementWithClass = document.querySelector('.brand');
                    firstElementWithClass.addEventListener('click', function (event) {
                        if ($mobileNavLi.classList.contains('is-active')) {
                            $navbarBurger.classList.remove('is-active');
                            $mobileNavLi.classList.remove('is-active');
                        }
                        // $navbarBurger.classList.toggle('is-active');
                        // $mobileNavLi.classList.toggle('is-active');
                    });
                }
            });
        }


}
